"use client"; // This directive is necessary for Next.js App Router to mark this as a client component
import React, { useEffect } from 'react';
import { useTheme } from './ThemeContext'; // Adjust the import path to your ThemeContext.js/jsx file
import mode from '../../audio/light-dark.mp3'


const ThemeToggle = () => {
 const { theme, toggleTheme } = useTheme();
 const audio = new Audio(mode);
const soundEffect=()=>{
    audio.play().catch(function (error) {
    console.log("Sound error")});
}
useEffect(()=>{
document.getElementById("toggle").addEventListener("change", function (e) {
  e.preventDefault();
  soundEffect()
  if (e.target.checked) {
    document.getElementById("toggle-div").classList.add("night");
  } else {
    document.getElementById("toggle-div").classList.remove("night");
  }
});
},[])


  return (
     <div ><label htmlFor="toggle" id="toggle-label">
  <div id="toggle-div">
    <input type="checkbox" id="toggle"   onChange={(e) => {
    const isChecked = e.target.checked;
    toggleTheme();
    if (isChecked && theme==='day') {
      document.getElementById("toggle-div").classList.add("night");
    } else {
      document.getElementById("toggle-div").classList.remove("night");
    }
  }} />
    <div className="clouds">
      <div className="cloud cloud-1"></div>
      <div className="cloud cloud-2"></div>
      <div className="cloud cloud-3"></div>
      <div className="cloud cloud-4"></div>
      <div className="cloud cloud-5"></div>
    </div>
    <div className="backdrops">
      <div className="backdrop"></div>
    </div>
    <div className="stars">
      <div className="star star-1"></div>
      <div className="star star-2"></div>
      <div className="star star-3"></div>
    </div>
    <div className="sun-moon">
      <div className="crater"></div>
    </div>
  </div>
</label>
 </div>
  );
};

export default ThemeToggle;
